import type { Action } from 'redux';
import type { AdPartner } from '../../../../main/types/adPartnerTypes';

export const SELECT = 'AD_PARTNER_SELECT';

export function selectPartner({ partner }: { partner: AdPartner | null | undefined }): SelectPartnerAction {
  return {
    type: SELECT,
    data: partner,
  };
}

export type SelectPartnerAction = Action<typeof SELECT> & { data: AdPartner | null | undefined };
